export const concatUrls = (basePath, appendix) => {
    const normalizedBasePath = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath;
    const normalizedAppendix = appendix.startsWith('/') ? appendix.substring(1) : appendix;
    return `${normalizedBasePath}/${normalizedAppendix}`;
};
// RFC 3986 - compliant encoding
export const fixedEncodeURIComponent = (text) => {
    return encodeURIComponent(text).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
};
export const removeURLParameter = (url, parameter) => {
    const [path, params] = url.split('?');
    if (params) {
        const urlParams = new URLSearchParams(params);
        urlParams.delete(parameter);
        const paramsRes = urlParams.toString();
        return paramsRes ? `${path}?${paramsRes}` : path;
    }
    return url;
};
